import React, { FC, PropsWithChildren } from "react";
import { HeroProduct, HeroProductProps } from "../../components/HeroProduct";

type Props = PropsWithChildren<{
  heroProduct: HeroProductProps;
}>;

export const ProductPage: FC<Props> = ({ heroProduct, children }) => (
  <main className="flex flex-col gap-lg tablet:gap-xxl desktop:gap-xxxl mb-lg tablet:mb-xxl desktop:mb-xxxl">
    <HeroProduct {...heroProduct} />

    {children}
  </main>
);
